// Офлайн-фикстуры соц-данных карточки товара: отзывы и вопросы (fd-review-02/03).
// Реальные данные отдаёт gateway (миграция 042); мок нужен только когда стек
// поднят без `BUN_PUBLIC_API_GATEWAY_URL`. Ключ — id товара из ./data.ts.
import type { ProductReview } from "../types";

// Отзывы по товарам. Не у всех товаров они есть — так ближе к реальности.
export const mockProductReviews: Record<string, ProductReview[]> = {
	"prod-1": [
		{
			id: "rev-1-1",
			rating: 5,
			text: "Серьги ещё изящнее, чем на фото. Серебро приятного тёплого оттенка, застёжка надёжная. Ношу почти не снимая.",
			authorName: "Мария К.",
			variant: "Серебряный",
			photoUrls: [],
			createdAt: "2026-07-18T10:30:00Z",
		},
		{
			id: "rev-1-2",
			rating: 4,
			text: "Красивые, но чуть меньше, чем ожидала. В остальном претензий нет — упаковка аккуратная, доставка быстрая.",
			authorName: "Ольга П.",
			variant: "Серебряный",
			photoUrls: [],
			createdAt: "2026-06-30T14:05:00Z",
		},
		{
			id: "rev-1-3",
			rating: 5,
			text: "Брала в подарок сестре — восторг. Явно ручная работа, каждая деталь проработана.",
			authorName: "Дарья В.",
			photoUrls: [],
			createdAt: "2026-05-22T09:12:00Z",
		},
	],
	"prod-2": [
		{
			id: "rev-2-1",
			rating: 5,
			text: "Ваза шикарная, рельеф живой. Взяла 35 см — смотрится очень статусно на столе.",
			authorName: "Ирина С.",
			variant: "35 см",
			photoUrls: [],
			createdAt: "2026-07-02T18:40:00Z",
		},
		{
			id: "rev-2-2",
			rating: 3,
			text: "Сама ваза хорошая, но пришла с крошечным сколом на дне. Продавец предложил скидку, вопрос решили.",
			authorName: "Наталья Д.",
			variant: "25 см",
			photoUrls: [],
			createdAt: "2026-06-11T11:20:00Z",
		},
	],
	"prod-3": [
		{
			id: "rev-3-1",
			rating: 5,
			text: "Тёплый, мягкий, не колется совсем. Размер L сел свободно, как и хотела — оверсайз.",
			authorName: "Екатерина М.",
			variant: "L",
			photoUrls: [],
			createdAt: "2026-08-01T08:00:00Z",
		},
	],
};
